import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { scrollToCompra } from '../utils/scroll';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 500px, hide if near the bottom (purchase section)
      const scrollY = window.scrollY;
      const purchaseSection = document.getElementById('compra');
      let hideNearBottom = false;
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        hideNearBottom = rect.top < window.innerHeight;
      }
      setIsVisible(scrollY > 500 && !hideNearBottom);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-189">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-40 md:hidden flex justify-center" data-id="element-190">
          <button onClick={scrollToCompra} className="w-full max-w-md bg-brand-teal text-white font-bold py-4 px-6 rounded-lg shadow-lg active:scale-95 transition-transform flex justify-center items-center gap-2" data-id="element-191">
            QUIERO EL MEGA PACK AHORA →
          </button>
        </motion.div>}
    </AnimatePresence>;
}